import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import OptionModal from '../../../components/modals/option-modal';
import HomepageMessageModal from '../../../components/modals/external/external-message-modal';
import { ButtonComponent } from '../../../components/form/elements/button';
import GlobalModal from '../../../components/modals/modal';
import { ComponentShowcase, ComponentShowcaseTitle, LayoutRow } from '../index';
import css from '../index.module.css';
import customModalCss from './custom-modal.module.css';

export default function ModalShowcase() {
  const [modal, setModal] = useState(null);

  function MessageModalExample() {
    return (
      <HomepageMessageModal
        message={
          'This type of modal contain only message string (no formating) and OK btn'
        }
        onClose={() => setModal(null)}
      />
    );
  }

  function CustomModalExample() {
    const body = (
      <div className="text-center">
        <h1 className={customModalCss['title']}>REĢISTRĒTIES KĀ:</h1>

        <Trans
          i18nKey="pages.external.homepage.registration.text"
          components={{
            1: (
              <button
                name="physical"
                type="button"
                className={customModalCss['btn']}
                onClick={() => setModal(null)}
              />
            ),
            2: <span className={customModalCss['delimiter']} />,
            3: (
              <button
                name="legal"
                type="button"
                className={customModalCss['btn']}
                onClick={() => setModal(null)}
              />
            ),
          }}
        />
      </div>
    );

    return (
      <GlobalModal
        visible={true}
        buttons={null}
        body={body}
        onClose={() => setModal(null)}
      />
    );
  }

  function OptionModalExample() {
    return (
      <OptionModal
        title={'Modal title'}
        content={
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab dolorem ducimus harum magnam quam voluptatibus?'
        }
        buttons={[
          { title: 'Ienākt', name: 'Option1', value: 'Option1' },
          { title: 'Turpināt', name: 'Option2', value: 'Option2' },
        ]}
        onChoice={(choice) => {
          console.info('chosen', choice);
          setModal(null);
        }}
        onClose={() => setModal(null)}
      />
    );
  }

  return (
    <LayoutRow>
      <ComponentShowcase
        title="Modals (dialogs, popups)"
        shortDescription="Standard dialogs/modals/popups."
      >
        <ComponentShowcaseTitle title="All Modals are opened programmatic" />

        <div className={css['button-container']}>
          <ButtonComponent
            label="Message Modal"
            name="modal1"
            click={() => setModal(MessageModalExample)}
          />

          <ButtonComponent
            label="Custom html via Global Modal"
            name="modal2"
            click={() => setModal(CustomModalExample)}
          />

          <ButtonComponent
            label="Option modal (title + msg + option)"
            name="modal3"
            click={() => setModal(OptionModalExample)}
          />
        </div>

        {modal}
      </ComponentShowcase>
    </LayoutRow>
  );
}
